import React, { useState } from "react";
import {
  Plus,
  Folder,
  FolderPlus,
  Users,
  Upload,
  Search,
  ChevronDown,
  Database,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
 
const Create = () => {
  const [shareWithCompany, setShareWithCompany] = useState(true);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
 
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
 
 
    const handleCreateProject = () => {
      const projectNameInput = document.getElementById("projectName").value;
 
      if (!projectNameInput) {
        alert("Please enter project name");
        return;
      }
 
      if (!file) {
        alert("Please select a file");
        return;
      }
 
      const newProject = {
        name: projectNameInput,
        fileUrl: URL.createObjectURL(file), // temporary URL for preview
        fileName: file.name,
      };
 
      // Get existing projects from localStorage
      const existingProjects = JSON.parse(localStorage.getItem("projects")) || [];
 
      // Add new project
      existingProjects.push(newProject);
 
      // Save back to localStorage
      localStorage.setItem("projects", JSON.stringify(existingProjects));
 
      alert("Project saved!");
      
      // Optional: clear input and file
      document.getElementById("projectName").value = "";
      setFile(null);
  };
 
 
  
 
  return (
    <div className="flex h-screen bg-gradient-to-br from-[#0d1b2a] to-[#1a2d45] text-white">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0d1b2a]/80 backdrop-blur-lg border-r border-[#2d3e56] flex flex-col">
        {/* Logo */}
         <div className="flex items-center px-6 py-6 border-b border-[#2d3e56]">
          <img
            src="/assets/images/rlogo.png"
            alt="Redian Logo"
            className="h-12 w-100 object-contain mr-3"
          />
          {/* <span className="font-bold text-xl tracking-tight">Redian</span> */}
        </div>
 
        {/* Nav */}
        <nav className="flex-1 px-4 py-6 space-y-1">
          <Link
            to="/create"
            className="w-full flex items-center justify-center space-x-2 bg-blue-600/20 border border-blue-500/30 py-3 rounded-lg mb-6 transition-all duration-200 shadow-lg shadow-blue-600/20"
          >
            <Plus size={18} className="text-blue-400" />
            <span className="font-medium">Create Project</span>
          </Link>
 
          <Link
            to="/home"
            className="flex items-center space-x-3 px-3 py-3 rounded-lg hover:bg-[#2d3e56] cursor-pointer group transition-colors"
          >
            <Folder size={18} className="text-gray-400 group-hover:text-white" />
            <span className="text-gray-300 group-hover:text-white">Projects</span>
          </Link>
 
          <Link
            to="/templates"
            className="flex items-center space-x-3 px-3 py-3 rounded-lg hover:bg-[#2d3e56] cursor-pointer group transition-colors"
          >
            <FolderPlus
              size={18}
              className="text-gray-400 group-hover:text-white"
            />
            <span className="text-gray-300 group-hover:text-white">
              Templates
            </span>
          </Link>
 
          <Link
            to="/assemblies"
            className="flex items-center space-x-3 px-3 py-3 rounded-lg hover:bg-[#2d3e56] cursor-pointer group transition-colors"
          >
            <Database
              size={18}
              className="text-gray-400 group-hover:text-white"
            />
            <span className="text-gray-300 group-hover:text-white">
              Assemblies
            </span>
          </Link>
        </nav>
 
        {/* Footer */}
        <div className="px-4 py-4 border-t border-[#2d3e56]">
          <div className="text-sm text-gray-400 font-medium mb-2">
            Demo Projects
          </div>
          <div className="space-y-2">
            <div className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer py-1 transition-colors">
              Architecture Concept
            </div>
            <div className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer py-1 transition-colors">
              Urban Planning
            </div>
            <div className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer py-1 transition-colors">
              Landscape Design
            </div>
          </div>
          <div className="mt-6">
            <Link
              to="/"
              className="w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-red-400 border border-red-500/40 rounded-lg hover:bg-red-500/10 hover:text-red-300 transition-colors"
            >
              Logout
            </Link>
          </div>
        </div>
      </aside>
 
      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar */}
        <header className="flex items-center justify-between px-8 py-4 border-b border-[#2d3e56] bg-[#0d1b2a]/50 backdrop-blur-sm">
          <div className="flex-1 h-16 max-w-2xl relative">
            <Search
              size={18}
              className="absolute left-3 top-6 transform -translate-y-1/2 text-gray-400"
            />
            <input
              type="text"
              placeholder="Search projects or folders..."
              className="w-full pl-10 pr-4 py-3 bg-[#1b263b] border border-[#2d3e56] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all"
            />
          </div>
          <div className="flex items-center space-x-4 ml-6">
            {/* <button className="flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-2 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg shadow-blue-600/20">
              <Users size={16} />
              <span className="font-medium">Invite Team</span>
            </button> */}
            <div className="flex items-center space-x-3">
              <div className="h-9 w-16 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center font-semibold shadow-lg">
                Admin
              </div>
              {/* <ChevronDown size={16} className="text-gray-400 cursor-pointer" /> */}
            </div>
          </div>
        </header>
 
        {/* Project Creation Form */}
        <div className="flex-1 flex items-center justify-center p-8 overflow-hidden">
          <div className="bg-[#1b263b]/80 backdrop-blur-lg rounded-2xl shadow-2xl w-full max-w-5xl flex border border-[#2d3e56] overflow-hidden">
            {/* Left side - Form */}
            <div className="flex-1 p-8 space-y-6">
              <div>
                <h2 className="text-2xl font-bold mb-2">Create New Project</h2>
                <p className="text-gray-400">
                  Start by naming your project and setting up permissions
                </p>
              </div>
 
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Project Name
                  </label>
                 <input
                    type="text"
                    id="projectName"
                    placeholder="Enter project name..."
                    className="w-full px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all"
                  />
                  
                </div>
 
                {/* Share toggle */}
                <div className="flex items-center justify-between p-4 bg-[#0d1b2a] rounded-xl border border-[#2d3e56]">
                  <span className="flex items-center space-x-3">
                    <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center font-semibold">
                      TR
                    </div>
                    <div>
                      <div className="font-medium">Share with company</div>
                      <div className="text-sm text-gray-400">
                        All team members can access
                      </div>
                    </div>
                  </span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={shareWithCompany}
                      onChange={() => setShareWithCompany(!shareWithCompany)}
                      className="sr-only"
                    />
                    <div className="w-12 h-6 bg-gray-700 rounded-full peer peer-checked:bg-blue-600 transition-all duration-300"></div>
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full peer-checked:translate-x-6 transition-all duration-300 shadow-lg"></div>
                  </label>
                </div>
 
                <button className="w-full flex items-center justify-center space-x-2 px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl hover:bg-[#2d3e56] transition-colors group">
                  <Users
                    size={18}
                    className="text-gray-400 group-hover:text-white"
                  />
                  <span className="text-gray-300 group-hover:text-white">
                    Invite guests or team members
                  </span>
                </button>
 
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Project Template
                  </label>
                  <select className="w-full px-4 py-3 bg-[#0d1b2a] border border-[#2d3e56] rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all">
                    <option>Start from scratch</option>
                    <option>Architecture Template</option>
                    <option>Urban Planning Template</option>
                    <option>Landscape Design Template</option>
                  </select>
                </div>
 
                <button
                  onClick={handleCreateProject}
                  className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all font-medium shadow-lg shadow-blue-600/20"
                >
                  Create Project
                </button>
              </div>
            </div>
 
            {/* Right side - File Upload */}
            <div className="flex-1 border-l border-[#2d3e56] p-8">
              <div className="h-full flex flex-col items-center justify-center border-2 border-dashed border-[#2d3e56] rounded-2xl p-8 hover:border-blue-500/50 transition-all duration-300 group">
                <div className="text-center space-y-4">
                  <div className="inline-flex p-4 bg-blue-500/10 rounded-2xl">
                    <Upload size={32} className="text-blue-400" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2">Upload Map View</h3>
                  <p className="text-gray-400 text-sm">
                    Drag & Drop your files here or browse
                  </p>
 
                  <div className="bg-[#0d1b2a] rounded-lg p-4 border border-[#2d3e56]">
                    <p className="text-sm font-medium mb-2">Supported formats:</p>
                    <p className="text-xs text-gray-400 leading-6">
                      PDF, DWG, DXF, DWF, DGN, PNG, TIFF, JPG, JPEG, BMP, EMF, GIF
                    </p>
                  </div>
 
                  {/* File input */}
                  <input
                    type="file"
                    id="fileUpload"
                    onChange={handleFileChange}
                    className="hidden"
                  />
                  <label
                    htmlFor="fileUpload"
                    className="px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all font-medium shadow-lg shadow-blue-600/20 cursor-pointer"
                  >
                    Browse Files
                  </label>
 
                  {/* Show selected file */}
                  {file && (
                    <p className="text-sm text-gray-300 mt-3">
                      Selected: <span className="font-medium">{file.name}</span>
                    </p>
                  )}
 
                  {/* Upload button */}
                  {/* <button
                    onClick={handleUpload}
                    className="mt-4 px-6 py-2 bg-green-600 rounded-lg hover:bg-green-700 transition-all font-medium shadow-lg shadow-green-600/20"
                  >
                    Upload File
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
 
export default Create;
 
 
 